<template>
    <ul class="my-6">
        <StepConfigurationItem
            v-for="(input, inputIndex) in formInputs"
            :key="`input-${inputIndex}`"
            :inputs="form.inputs"
            :selectedValue="selectedValue"
            :stepIndex="stepIndex"
            :title="title"
            @select-step="gotToStep"
        />
    </ul>
</template>

<script>
    import StepConfigurationItem from '@/components/myHabiteoStudio/steps/components/StepConfigurationItem';

    export default {
        name: 'StepConfiguration',
        components: {
            StepConfigurationItem
        },
        props: {
            form: {
                type: Object,
                required: true
            },
            selectedValue: {
                type: [Number, Boolean],
                required: false
            },
            stepIndex: {
                type: Number,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                summary: true
            }
        },
        computed: {
            formInputs() {
                return this.form.inputs ? this.form.inputs.filter( el => el.id !== 'advanced_preset' ) : '';
            }
        },
        methods: {
            gotToStep(step) {
                this.$emit('select-step', step);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepConfiguration.vue